module.exports = __webpack_public_path__ + "static/media/amex.157f5309.svg";